﻿window.cFichier = function (bddRef, url, tailleOctet, dcr, dmo) {
    var Me = this;

    this.isDirectory = false
    if (url != null && (url.endsWith("/") || url.endsWith(".repertoire"))) { this.isDirectory = true } //".repertoire" pour la corbeille

    this.mGetLib1 = function (option) {
        //if (url.startsWith("~")) url = url.substring(1)
        var txt = ""
        if (url != null) {
            if (this.isDirectory) {
                var directory = url
                if (directory.endsWith(".repertoire")) {
                    directory = directory.substring(0, directory.length - ".repertoire".length)
                } else {
                    directory = directory.substring(0, url.length - 1)
                }
                txt = directory.substring(directory.lastIndexOf("/") + 1)
            } else {
                txt = url.substring(url.lastIndexOf("/") + 1)
            }
        }
        else { txt = ((objetFichier == null) ? this.mGetLibBase() : objetFichier.mGetLibBase()); }
        if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetPath = function () {
        if (url.startsWith("data:")) {
            return ""
        } else {
            return url.substring(0, url.lastIndexOf("/"))
        }
    }
    this.mGetPathDocument = function () {
        var path = this.mGetPath()
        if (path.startsWith("~")) path = path.substring(1)
        path = path.substring(("/fichier/" + bddRef.nom_base).length)
        if (this.isInBrouillon()) {
            path = path.substring(("/utidoc/" + bddRef.utiCourant.id_utilisateur).length)
            path = "/Vos documents" + path.substring(("/Vos documents").length)
        } else if (this.isInDocumentPartage()) {
            path = "/Documents partagés" + path.substring(("/documents_partages").length)
        } else if (this.isInDocumentPublic()) {
            path = "/Documents publics" + path.substring(("/documents_publics").length)
        }
        return path
    }

    this.isInCorbeille = function () {
        var idFichier = url
        if (idFichier.startsWith("~")) idFichier = idFichier.substring(1)
        return idFichier.toLowerCase().startsWith(bddRef.repertoireCorbeille.substring(1).toLowerCase())
    }
    this.isInBrouillon = function () {
        var idFichier = url
        if (idFichier.startsWith("~")) idFichier = idFichier.substring(1)
        return idFichier.toLowerCase().startsWith(bddRef.repertoireBrouillon.substring(1).toLowerCase())
    }
    this.isInDocumentPartage = function () {
        var idFichier = url
        if (idFichier.startsWith("~")) idFichier = idFichier.substring(1)
        return idFichier.toLowerCase().startsWith(bddRef.repertoireRacineDocumentPartage.substring(1).toLowerCase())
    }
    this.isInDocumentPublic = function () {
        var idFichier = url
        if (idFichier.startsWith("~")) idFichier = idFichier.substring(1)
        return idFichier.toLowerCase().startsWith(bddRef.repertoireRacineDocumentPublic.substring(1).toLowerCase())
    }
    this.isInTemporaire = function () {
        var idFichier = url
        if (idFichier.startsWith("~")) idFichier = idFichier.substring(1)
        return idFichier.startsWith(bddRef.repertoireTemporaire.substring(1))
    }

    //nom fichier
    this.mGetNom = function () {
        if (url.startsWith("data:")) {
            return "image." + this.mGetExtension()
        } else {
            if (url.endsWith("/")) {
                var newUrl = url.substring(0, url.length - 2)
                return newUrl.substring(newUrl.lastIndexOf("/") + 1)
            } else {
                return url.substring(url.lastIndexOf("/") + 1)
            }

        }
    }
    this.mGetNomWithoutExtension = function () {
        var nom = this.mGetNom()
        if (nom.contains(".")) nom = nom.substring(0, nom.lastIndexOf("."))
        return nom
    }

    //image fichier
    this.mGetElementImage = function (height, width, tooltip, showImgJauge) {
        if (typeof showImgJauge == 'undefined') showImgJauge = true
        if (url.endsWith("/") || url.endsWith(".repertoire")) {
            if (url.startsWith("~/fichier/" + bddRef.nom_base + "/Document")) { return $("<i class='fas fa-folder-open'/>") }
            else { return $("<i class='fas fa-folder-closed' style='color:rgb(255, 193, 7);'/>") }
        }
        else {
            switch (this.mGetExtension()) {
                case "emlz": return $("<i class='fas fa-envelope-open-text'/>"); break;
                case "formz": return $("<i class='fafa fafa-formulaire'/>"); break;
                case "docz": return $("<i class='fas fa-file-lines'/>"); break;
                case "dcptz": return $("<i class='fafa fafa-file-invoice-euro'/>"); break;
                case "htmo": return $("<i class='fas fa-file-code'/>"); break;
                case "doch": return $("<i class='fas fa-file-word'/>"); break;
                case "htma": return $("<i class='fas fa-file-code'/>"); break;
                case "scha": return $("<i class='fafa fafa-file-invoice-euro'/>"); break;
                case "inline": return $("<i class='fas fa-code'/>"); break;
                case "rar": case "zip": return $("<i class='fas fa-file-archive'/>"); break;
                case "mp4": case "webm": case "mov": case "wmv": case "mpeg": case "mpg": case "ogv":
                    var nomFichier = ((url.startsWith("~")) ? url.substring(1) : url)
                    nomFichier = ((nomFichier.startsWith("//")) ? nomFichier.substring(1) : nomFichier)
                    // Séparer le chemin et le fichier
                    var path = nomFichier.substring(0, nomFichier.lastIndexOf("/") + 1);
                    var file = nomFichier.substring(nomFichier.lastIndexOf("/") + 1);
                    // Encoder uniquement le nom du fichier
                    var src = path + encodeURIComponent(file);
                    var $Video = $("<video muted loop poster='" + parametre.urldispatch + "/img/video_poster.png'><source src='" + src + "' type='video/" + this.mGetExtension() + "'></video>")
                    $Video.css("max-height", "100%")
                    $Video.css("width", "100%")
                    return $Video
                    break;
                case "png": case "bmp": case "jpg": case "jpeg": case "gif": case "tif": case "svg":
                    var nomFichier = ((url.startsWith("~")) ? url.substring(1) : url)
                    nomFichier = ((nomFichier.startsWith("//")) ? nomFichier.substring(1) : nomFichier)
                    // Séparer le chemin et le fichier
                    var path = nomFichier.substring(0, nomFichier.lastIndexOf("/") + 1);
                    var file = nomFichier.substring(nomFichier.lastIndexOf("/") + 1);
                    // Encoder uniquement le nom du fichier
                    var src = path + encodeURIComponent(file);

                    var $Div = $("<div style='position:relative;height:100%;min-height:100%;width:100%;min-width:100%;overflow:hidden;'/>")
                    if (typeof height != 'undefined' && height != null) $Div.css("height", height + "px")
                    if (typeof width != 'undefined' && width != null) $Div.css("width", width + "px")
                    var $img = null
                    var $ImgJauge = null
                    if (nomFichier.toLowerCase().startsWith(bddRef.repertoireCorbeille.substring(1) + "/")) { return $("<i class='fas fa-image'/>"); }
                    else {
                        $img = $("<div style='height:100%;width:100%;'/>");
                        $img.css({
                            "background-image": 'url("' + src + "" + (src.startsWith("data:") ? "" : "?d=" + (new Date()).getTime()) + '")',
                            "background-size": "cover",
                            "background-position": "center",
                            "background-repeat": "no-repeat"
                        });
                        //$img.attr("src", encodeURI(nomFichier) + "?d=" + (new Date).getTime())
                        //$ImgJauge = $("<img src='" + parametre.urldispatch + "/img/jauge.gif' style='" + ((showImgJauge) ? "" : "display:none;") + "position:absolute;z-index:1;width:30px;padding:5px;'/>").appendTo($Div)
                        //if (this.mGetExtension() != "svg") $img.css("position", "absolute")
                        //$img.css("display", "none")
                        $img.appendTo($Div)
                        if (typeof tooltip == 'undefined' || tooltip) {
                            var dxToolTip = $("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({
                                target: $Div,
                                position: "bottom",
                                contentTemplate: function (contentElement) {
                                    var w = $Div.innerWidth() * 4
                                    var h = $Div.innerHeight() * 4
                                    var $ImgTT = $("<img style='width:" + w + "px;height:" + h + "px;'/>")
                                    $ImgTT.attr("src", encodeURI(nomFichier) + "?d=" + (new Date).getTime())
                                    $("<div style='font-size:110%;'></div>").appendTo(contentElement).append($ImgTT);
                                }
                            }).dxCtrlTooltipHoverTarget("instance");
                        }
                    }
                    ////if (nomFichier.startsWith("data:")) { $img = $("<img src='" + nomFichier + "'/>"); }
                    ////else {
                    ////    if (nomFichier.toLowerCase().startsWith(bddRef.repertoireCorbeille.substring(1) + "/")) { return $("<i class='fas fa-image'/>"); }
                    ////    else {

                    ////        $img = $("<img style='z-index:0;'/>");
                    ////        $img.attr("src", encodeURI(nomFichier) + "?d=" + (new Date).getTime())
                    ////        $ImgJauge = $("<img src='" + parametre.urldispatch + "/img/jauge.gif' style='" + ((showImgJauge) ? "" : "display:none;") + "position:absolute;z-index:1;width:30px;padding:5px;'/>").appendTo($Div)
                    ////    }
                    ////}
                    ////if (this.mGetExtension() != "svg") $img.css("position", "absolute")
                    ////$img.css("display", "none")
                    //$img.appendTo($Div)
                    //if (typeof tooltip == 'undefined' || tooltip) {
                    //    var dxToolTip = $("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({
                    //        target: $Div,
                    //        position: "bottom",
                    //        contentTemplate: function (contentElement) {
                    //            var w = $Div.innerWidth() * 4
                    //            var h = $Div.innerHeight() * 4
                    //            var $ImgTT = $("<img src='" + $img.attr("src") + "' style='width:" + w + "px;height:" + h + "px;'/>")
                    //            $("<div style='font-size:110%;'></div>").appendTo(contentElement).append($ImgTT);
                    //        }
                    //    }).dxCtrlTooltipHoverTarget("instance");
                    //}
                    ////$img.on("load", function (e) {
                    ////    if ($ImgJauge != null) $ImgJauge.fadeOut(0, "swing", function () { $ImgJauge.remove(); $ImgJauge=null })

                    ////    var newHeight = null
                    ////    var newWidth = null
                    ////    mResize()
                    ////    resizeObserver.mAdd($Div, function () { mResize() })

                    ////    if (typeof tooltip == 'undefined' || tooltip) {
                    ////        var dxToolTip = $("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({
                    ////            target: $Div,
                    ////            position: "bottom",
                    ////            contentTemplate: function (contentElement) {
                    ////                var w = newWidth * 4
                    ////                var h = newHeight * 4
                    ////                var $ImgTT = $("<img src='" + $img.attr("src") + "' style='width:" + w + "px;height:" + h + "px;'/>")
                    ////                $("<div style='font-size:110%;'></div>").appendTo(contentElement).append($ImgTT);
                    ////            }
                    ////        }).dxCtrlTooltipHoverTarget("instance");
                    ////    }

                    ////    function mResize() {
                    ////        var naturalWidth = $img[0].naturalWidth
                    ////        var naturalHeight = $img[0].naturalHeight
                    ////        var widthDiv = ((typeof height != 'undefined' && height != null) ? height : $Div.innerWidth())
                    ////        var heightDiv = ((typeof width != 'undefined' && width != null) ? width : $Div.innerHeight())
                    ////        var top = null
                    ////        var left = null
                    ////        if (widthDiv > heightDiv) {
                    ////            if (naturalWidth > naturalHeight) {
                    ////                newWidth = naturalWidth / naturalHeight * heightDiv
                    ////                newHeight = heightDiv
                    ////            } else {
                    ////                newHeight = naturalHeight / naturalWidth * widthDiv
                    ////                newWidth = widthDiv
                    ////            }
                    ////            top = (heightDiv - newHeight) / 2
                    ////            left = (widthDiv - newWidth) / 2
                    ////        } else {
                    ////            if (naturalWidth > naturalHeight) {
                    ////                newWidth = naturalWidth / naturalHeight * heightDiv
                    ////                newHeight = heightDiv
                    ////            } else {
                    ////                newHeight = heightDiv
                    ////                newWidth = naturalWidth / naturalHeight * heightDiv
                    ////            }
                    ////            top = (heightDiv - newHeight) / 2
                    ////            //top = 0
                    ////            left = (widthDiv - newWidth) / 2
                    ////        }
                    ////        $img.css({
                    ////            "min-height": newHeight + "px",
                    ////            "max-height": newHeight + "px",
                    ////            "min-width": newWidth + "px",
                    ////            "max-width": newWidth + "px"
                    ////        })
                    ////        $img.css({ "top": top + "px", "left": left + "px" })
                    ////        $img.css("display", "")
                    ////    }
                    ////})
                    //$img.on("error", function (e) {
                    //    $img.css("display", "")
                    //    if ($ImgJauge != null) {
                    //        $ImgJauge.remove();
                    //        $ImgJauge = null;
                    //    }
                    //})
                    return $Div
                    break;
                case "wav": return $("<i class='fas fa-file-audio'/>"); break;
                case "csv": return $("<i class='fas fa-file-csv'/>"); break;
                case "xls": case "xlsx": case "xlsm": return $("<i class='fas fa-file-excel'/>"); break;
                case "pdf": return $("<i class='fas fa-file-pdf'/>"); break;
                case "pptx": case "pptm": case "ppt": case "potx": case "potm": case "pot": case "ppsm": return $("<i class='fas fa-file-powerpoint'/>"); break;
                //case "mov": return $("<i class='fas fa-file-video'/>"); break;
                case "doc": case "docx": return $("<i class='fas fa-file-word'/>"); break;
                default: return $("<i class='fas fa-file'/>"); break;
            }
        }
    }

    //extension fichier
    this.mGetExtension = function () {
        if (url.startsWith("data:")) {
            var deb = url.split(";")[0]
            return deb.split("/")[1].toLowerCase();
        } else {
            if (url.lastIndexOf(".") == -1) { return "" }
            else { return url.substring(url.lastIndexOf(".") + 1).toLowerCase() }
        }
    }

    // isImage
    this.mIsImage = function () {
        switch (this.mGetExtension()) {
            case "png": case "bmp": case "jpg": case "jpeg": case "gif": case "tif": return true; break;
            default: return false; break;
        }
    }

    //this.urlPublicAbsolue = function () {
    //    if (this.isInDocumentPublic()) {
    //        var path = url
    //        if (path.startsWith("~")) path = path.substring(1)
    //        path = path.substring(("/fichier/" + bddRef.nom_base + "/documents_publics/").length)
    //        if (parametre.isLocalhost) {
    //            return parametre.url_appli + "/file/" + bddRef.nom_base + "/" + path
    //        } else {
    //            return "https://doc." + parametre.domaine + "/file/" + bddRef.nom_base + "/" + path
    //        }

    //    } else { return "" }
    //}

    this.urlPublicAbsolue = function () {
        if (this.isInDocumentPublic()) {
            var path = url
            if (path.startsWith("~")) path = path.substring(1)
            path = path.substring(("/fichier/" + bddRef.nom_base + "/documents_publics/").length)

            var morceaux = path.replace(/\\/g, "/").split("/");
            for (var i = 0; i < morceaux.length; i++) {
                morceaux[i] = encodeURIComponent(morceaux[i]);
            }
            if (parametre.isLocalhost) {
                if (this.isDirectory) {
                    return parametre.url_appli + "/" + bddRef.nom_base + "/" + morceaux.join("/") + "folderp";
                } else {
                    return parametre.url_appli + "/" + bddRef.nom_base + "/" + morceaux.join("/") + "/filep";
                }
            } else {
                if (this.isDirectory) {
                    return "https://doc." + parametre.domaine + "/" + bddRef.nom_base + "/" + morceaux.join("/") + "folderp";
                } else {
                    return "https://doc." + parametre.domaine + "/" + bddRef.nom_base + "/" + morceaux.join("/") + "/filep";
                }
            }
        } else { return "" }
    }

    this.mGetIcone = function (container) {
        var ele = null
        if (typeof container == 'undefined') { ele = Me.mGetElementImage() }
        else { ele = Me.mGetElementImage() }
        switch (this.mGetExtension()) {
            case "emlz": ele.attr("title", "Email"); break;
            case "docz": ele.attr("title", "Courrier"); break;
            case "dcptz": ele.attr("title", "Document comptable"); break;
            default: ele.attr("title", "Fichier"); break;
        }

        return ele
    }
    this.itemTemplateGrille = function (contentElement, type) {
        if (this.isInCorbeille()) {
            contentElement.closest(".divtemplate").addClass("texture_corbeille")
            contentElement.closest(".divtemplate").css({
                "text-decoration": "line-through dotted"
            })
        }
        var $Table = $("<table style='table-layout:fixed;width:100%;'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;line-height:1;'/>").appendTo($Tr)
        if (this.isDirectory) {
            $Td.css({
                "font-size": "140%",
                "font-variant": "small-caps",
                "font-weight": 500
            })
            contentElement.closest(".divtemplate").css({ "border": "1px dotted yellow" })
        }
        $Td.text(this.mGetLib1())
        $Td.attr("title", this.mGetLib1())
        if (this.isInDocumentPublic()) {
            //on est dans le répertoire public
            //on affiche l'url public
            var $DivUrl = $("<div style='width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;opacity:0.5;font-size:14px;'/>").appendTo($Td)
            var url = this.urlPublicAbsolue()
            var $SpanLink = $("<span class='state-hover dx-theme-accent-as-text-color' style='font-size:100%;opacity:1;padding-right:5px;'></span>").appendTo($DivUrl)
            $SpanLink.attr("title", "Cliquer pour copier l'adresse dans le presse-papier")
            $SpanLink.html("<i class='fas fa-copy'></i>")
            $SpanLink.on("click", function (e) {
                e.stopPropagation()
                var $temp = $("<input>");
                $("body").append($temp);
                $temp.val(url).select();
                document.execCommand("copy");
                $temp.remove();
                mNotify("L'adresse du fichier a été copiée dans le presse-papier", "success", 6000)
            })
            var $a = $("<a href='javascript:void(0)' style='font-family:barlow condensed;'>" + url + "</a>").appendTo($DivUrl)
            $a.attr("title", url + "<br/>Partagez ce lien pour donner l'accès à votre fichier.")
            if (this.isDirectory) {
                $a.on("click", function (e) {
                    e.stopPropagation()
                    window.open(url, "_blank")
                })
            }
        } else {
            var $U = $("<br/><u style='font-family:barlow condensed;font-size:12px;opacity:0.5;'>" + Me.mGetPathDocument() + "</u>").appendTo($Td)
        }

        if (typeof tailleOctet != 'undefined' && !this.isDirectory) {
            var $Td = $("<td style='font-family:barlow condensed;width:50px;text-align:right;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:80%;font-variant:" + ((this.isDirectory) ? "small-caps" : "normal") + ";opacity:0.5;vertical-align:top;'>" + tailleOctet.sizeFile() + "</td>").appendTo($Tr)
        }
    }
    this.itemTemplateGrillePlus = function (contentElement, option) {
        var $Span = $("<div style=''><i class='fas fa-certificate dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dcr.toDateIlya(true) + "</div>").appendTo(contentElement)
        var title = "<i class='fas fa-certificate dx-theme-accent-as-text-color' style='padding-right:3px;'></i> Créé le " + dcr.toFrenchDateTime()

        if (dmo.toDateIlya(true) != dcr.toDateIlya(true)) {
            var $Span = $("<div style=''><i class='fas fa-pen dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dmo.toDateIlya(true) + "</div>").appendTo(contentElement)
            title += "<br/><i class='fas fa-certificate dx-theme-accent-as-text-color' style='padding-right:3px;'></i> Modifié le " + dmo.toFrenchDateTime()
        }

        if (this.isInDocumentPublic()) {
            if (option.dacces) {
                var $S = $("<div><i class='fas fa-eye dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + option.dacces.toDateIlya(true) + "</div>").appendTo($Span)
                title += "<br/><i class='fas fa-eye dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Dernière consultation " + option.dacces.toFrenchDateTime()
            } else {
                var $S = $("<div><i class='fas fa-eye dx-theme-accent-as-text-color' style='padding-right:3px;'></i> aucune</div>").appendTo($Span)
                title += "<br/><i class='fas fa-eye dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Aucuen consultation"
            }
        }

        contentElement.attr("title", title)

    }

    var dataImgPosterVideo = "data:image/svg+xml;base64,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"
}